import React from "react";
import { SearSearchNormalO } from "lovedicons/dist/searO";
// import { EsseSortO } from "lovedicons/dist/esseO";
// import { ArrArrow3O } from "lovedicons/dist/arrO";

const TableHeadOptions = ({
  title,
  searchQuery,
  handleSearchChange,
  toggleFilter,
  isSortedLatest,
  filterDate,
  setFilterDate,
}) => {
  return (
    <main>
      <div className="w-full flex flex-col lg:flex-row justify-between items-center gap-2 lg:gap-0">
        <div className="w-full flex flex-col md:flex-row gap-2 md:gap-10">
          <div className="w-full text-lg md:text-xl xl:text-2xl flex items-center justify-start font-bold text-gray-800">
            {title}
          </div>
          <div className="w-full flex-grow relative flex items-center">
            <div className="flex-grow">
              <input
                type="search"
                placeholder="Wow No./Frame No."
                value={searchQuery}
                onChange={handleSearchChange}
                className="flex-grow w-full border rounded-lg py-2 pl-4 pr-8 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <div>
                <SearSearchNormalO className="absolute top-3 right-3 h-5 w-5 text-black cursor-pointer" />
              </div>
            </div>
          </div>
        </div>

        <div className="w-full flex flex-row gap-2 lg:gap-3 justify-between md:justify-end">
          <div className="flex items-center justify-center font-medium">
            Sort by created:
            <div
              className="ml-2 py-1 px-2 bg-purple-100 rounded-lg cursor-pointer"
              onClick={toggleFilter}
            >
              {isSortedLatest ? "Z-A" : "A-Z"}
            </div>
            {/* <EsseFilterO className="h-5 w-5 text-black cursor-pointer" /> */}
            {/* <EsseSortO className="h-6 w-6 text-black cursor-pointer" />
            <ArrArrow3O className="h-6 w-6 text-black cursor-pointer" /> */}
          </div>

          <div className="flex flex-col text-xs">
            <div className="font-medium">From (Created)</div>
            <input
              type="date"
              value={filterDate?.startDate}
              onChange={(e) =>
                setFilterDate((prevState) => ({
                  ...prevState,
                  startDate: e.target.value,
                }))
              }
              className="mt-[2px] py-1 px-2 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer"
            />
          </div>
          <div className="flex flex-col text-xs">
            <div className="font-medium">To (Created)</div>
            <input
              type="date"
              value={filterDate?.endDate}
              onChange={(e) =>
                setFilterDate((prevState) => ({
                  ...prevState,
                  endDate: e.target.value,
                }))
              }
              className="mt-[2px] py-1 px-2 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer"
            />
          </div>
        </div>
      </div>

      {/* <div>
        {isFilterExpanded && (
          <div className=" p-4  rounded-lg">
            <div className="flex justify-end space-x-4">
              <select className="border rounded-lg py-2 px-4 focus:outline-none focus:ring-2 focus:ring-blue-500">
                <option>Wow Number</option>
                <option>Frame Number</option>
              </select>
              <select className="border rounded-lg py-2 px-4 focus:outline-none focus:ring-2 focus:ring-blue-500">
                <option>IS</option>
                <option>IS NOT</option>
              </select>
              <select className="border rounded-lg py-2 px-4 focus:outline-none focus:ring-2 focus:ring-blue-500">
                <option>True</option>
                <option>False</option>
              </select>
              <button className="py-2 px-4 bg-blue-500 text-white rounded-lg hover:bg-blue-600">
                Run
              </button>
              <button className="py-2 px-4 bg-gray-300 rounded-lg hover:bg-gray-400">
                And
              </button>
              <button className="py-2 px-4 bg-gray-300 rounded-lg hover:bg-gray-400">
                OR
              </button>
            </div>
          </div>
        )}
      </div> */}
    </main>
  );
};

export default TableHeadOptions;
